import AuditByDeliveryCsvResponseSchema from '@/schema/AuditByDeliveryCsvResponse.schema'
import AuditByDeliveryResponse from '@/model/response/AuditByDeliveryResponse'

export default class AuditByDeliveryCsvResponse extends AuditByDeliveryResponse {

  readonly $endpoint: string = '/user/indicador/auditoria-entrega-csv'

  get $schema() {
    return AuditByDeliveryCsvResponseSchema(this)
  }

}
